<template>
  <div class="line">
    <div class="line-box clear">
      <div
        v-for="(line, index) in lineList"
        :key="index"
        class="line-item-box clear"
      >
        <div v-for="(item, index) in line" :key="index" class="line-item">
          <div class="line-head">
            <img :src="item.headImg" alt="headImg" />
          </div>
          <div class="line-cont-box">
            <div class="line-cont">
              <div class="v-line-desc text-overflow">
                {{ item.desc }}
              </div>
            </div>
            <div v-maidian="'line_' + index" class="line-btm clear">
              <div class="price">
                <span class="price-span">{{
                  discount ? item.price * 0.8 : item.price
                }}</span>
                <mt-button @click="jumpToSight(item.linkId)" size="small"
                  >立即预订</mt-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      discount: false,
      lineList: [
        [
          {
            headImg:
              'https://img1.qunarzz.com/vs_ceph_b2c_001/371fd4cf-e87a-47ae-ba4f-44dd7fb0e12a.jpg_r_640x420x95_3206af3a.jpg',

            tagList: ['海鲜自助', '海岛游'],
            price: 119,
            desc: '济南出发-跟团游 济南1日游 趵突泉景区+大明湖景区+黑虎泉+芙蓉街纯玩一日游 【 畅游趵突泉 明湖泛舟 步行解锁老济南】',
            linkId:
              'https://touch.dujia.qunar.com/p/item/976407605?date=2023-01-05',
            discountId: '3401723685',
          },
          {
            headImg:
              'https://img1.qunarzz.com/vs_ceph_b2c_001/36432667-bf68-4bac-abd3-e547fbf56374.jpg_r_640x420x95_df159539.jpg',
            tagList: ['雪山温泉', '草原'],
            price: 224,
            desc: '烟台出发-跟团游 【蓬莱一日游】蓬莱阁+八仙过海+八仙雕塑 纯玩一日游 无强制自费无购物',
            linkId:
              'https://touch.dujia.qunar.com/p/item/2243294103?date=2023-01-05',
            discountId: '1534603695',
          },
        ],
        [
          {
            headImg:
              'https://dimg04.c-ctrip.com/images/0300r120009gifh9z522E_C_750_420_Q90.jpg',
            tagList: ['网红打卡', '自驾游'],
            price: 499,
            desc: '秦皇岛+北戴河2日1晚跟团游',
            linkId:
              'https://touch.dujia.qunar.com/pg/cq-detail/index?pid=2718505020&ctrId=30309511&ctrDepId=147',
            discountId: '4078494581',
          },
          {
            headImg:
              'https://img1.qunarzz.com/p/tts7/1805/5c/b2fff2951f6e4b02.jpg_r_640x420x95_30d56353.jpg',
            tagList: ['熊猫基地', '探秘'],
            price: 120,
            desc: '石家庄出发-跟团游 石家庄到西柏坡一日游|红色旅游教育党建团精品推荐|散客天天发 二环内免费接送',
            linkId:
              'https://touch.dujia.qunar.com/p/item/1119298821?date=2023-01-05',
            discountId: '2625878855',
          },
        ],
      ],
    };
  },
  methods: {
    jumpToSight(linkId) {
      window.location.href = linkId;
    },
  },
};
</script>
<style lang='less' scoped='true'>
.line {
  position: relative;
  width: calc(100% - 30px);
  margin:0 auto;
  &-tit {
    width: 100%;
  }
}
.rem(@name,@px) {
  @{name}: unit(@px / 37.5, rem);
}
.line {
  position: relative;
  padding-top: 21px;
  .line-cont-box {
    width: calc(100% - 155px);
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  &-box {
    margin-top: 10px;
  }
  &-item {
    overflow: hidden;
    position: relative;
    border-radius: 4px;
    width: 100%;
    background-color: #fff;
    margin-bottom: 20px;
    float: left;
    z-index: 2;
    display: flex;
    &-box {
      position: relative;
      .bg-line {
        background: url(https://picbed.qunarzz.com/f85c6e94de1f40c4bae5c5a5c7261be5.png)
          no-repeat;
        background-size: 100% auto;
        height: 20px;
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 7px;
      }
    }
    &:nth-child(2n + 2) {
      float: right;
    }
  }
  &-desc {
    height: 32px;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 5px;
    text-align: left;
  }
  &-tag {
    padding-left: 2px;
    padding-right: 2px;
    padding-top: 3px;
    padding-bottom: 3px;
    border: 0.1em solid #ff414c;
    border-radius: 2px;
    color: #fff;
    font-size: 9px;
    float: left;
    margin-right: 5px;
  }
  &-cont {
    padding: 7px;
    font-size: 13px;
    font-family: NotoSansHans;
    font-weight: bold;
    color: #001f4e;
  }
  &-btm {
    padding: 7px;
    .price {
      display: flex;
      align-items: center;
      justify-content: space-between;
      &-span {
        height: 19px;
        line-height: 19px;
        text-align: left;
        font-size: 20px;
        color: #FF7E00;
        &.discount {
          color: #aaa9a9;
        }
        position: relative;
        &:before {
          content: '￥';
          font-size: 20px;
          position: relative;
        }
        &:after {
          content: '起/人';
          font-size: 11px;
          position: relative;
        }
      }
      button {
        position: relative;
        margin-right: 0 !important;
      }
    }
  }
  &-head {
    width: 155px;
    img {
      width: 100%;
      display: block;
      height: 103px;
    }
  }
  /deep/ .mint-button--small {
    border-radius: 10px !important;
    background-color: #FF7E00;
    border-radius: 9px;
    color: #fff;
    font-size: 13px;
    height: 24px;
    margin-left: auto;
    margin-right: auto;
  }
  .line-anchor {
    position: absolute;
    left: 0;
    top: 0;
    height: 18px;
    color: #fff;
    font-style: italic;
    text-align: center;
    letter-spacing: 3px;
    background: rgba(255, 63, 79, 1);
    border-radius: 3px 0px 3px 0px;
  }
}
</style>